import { render, staticRenderFns } from "./AsetJurnal.vue?vue&type=template&id=6b841888&scoped=true&"
import script from "./AsetJurnal.vue?vue&type=script&lang=js&"
export * from "./AsetJurnal.vue?vue&type=script&lang=js&"
import style0 from "./AsetJurnal.vue?vue&type=style&index=0&id=6b841888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b841888",
  null
  
)

export default component.exports